export default __webpack_public_path__ + "static/11-f22f3c6bb146e485ed814008ed86a2c0.svg";